import {
  listingAutresFacadesMock,
  listingFacadesMock as listingFacadesComponentMock,
  titreDescriptionMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(true, false), listingFacadesComponentMock, listingAutresFacadesMock];

export const listingFacadesMock: SlugPage = {
  ...pageBase({
    title: 'Listing Façades',
    type: 'facades',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
